export default "__VITE_ASSET__41ae21b9__"